import React from "react";
import { FileText, FileCheck, CreditCard, MousePointerClick, ChevronRight } from "lucide-react";
const timelineSteps = [{
  date: "26. 7. 18.(토)~8. 19.(수)\n\n\n\n",
  title: "지원서작성\n및 서류제출",
  icon: FileText,
  isActive: true,
  url: "https://go.kycu.ac.kr/bbs/jws_reg00.php"
}, {
  date: "8. 25.(화) 14:00\n\n\n\n",
  title: "합격자발표",
  icon: FileCheck,
  isActive: false
}, {
  date: "8. 25.(화)~8. 27.(목) 17:00\n\n\n\n",
  title: "등록금납부",
  icon: CreditCard,
  isActive: false
}, {
  date: "8. 31.(월)",
  title: "개강",
  icon: MousePointerClick,
  isActive: false
}];
export default function EnrollmentTimeline() {
  return <section id="enrollmenttimeline" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        {}
        <div className="flex flex-col md:flex-row gap-4 md:gap-8 mb-12 md:mb-16 md:items-end">
          <h2 className="text-3xl md:text-4xl font-bold font-default leading-tight text-foreground">
            2026학년도 후기<br />
            신편입 모집안내
          </h2>
          <div className="flex flex-col pb-1">
            <span className="text-sm text-muted-foreground font-medium mb-1">모집일정</span>
            <span className="text-lg font-semibold text-foreground">2026. 7. 18.(토)~2026. 8. 19.(수)<br /><br /><br /></span>
          </div>
        </div>

        {}
        <div className="relative w-full">
          {}
          <div className="absolute top-[2.5rem] left-0 w-full border-t border-dashed border-muted-foreground/40 z-0 hidden md:block" />

          <div className="flex flex-col md:grid md:grid-cols-4 gap-4 md:gap-0 relative z-10">
            {timelineSteps.map((step, i) => {
            const Icon = step.icon;
            return <div key={i} data-index={i} className="flex flex-col relative group">
                  {}
                  <div className="h-10 flex items-end justify-start md:justify-center pb-2 text-sm md:text-base lg:text-base font-bold text-[#003366] dark:text-foreground md:px-2">
                    {step.date}
                  </div>

                  {}
                  <div className="hidden md:flex h-8 justify-center relative">
                    <div className="w-px h-full bg-muted-foreground/30" />
                    <div className="absolute bottom-0 w-2 h-2 rounded-lg bg-muted-foreground/40 translate-y-1/2" />
                  </div>

                  {}
                  <div onClick={() => {
                if (step.url) window.open(step.url, '_blank');
              }} className={`
                      h-40 p-6 flex flex-col justify-between relative transition-all duration-300 rounded-md md:rounded-none
                      ${step.url ? 'cursor-pointer' : ''}
                      ${step.isActive ? "bg-[#FFCC00] border-[3px] border-[#003366] z-20 shadow-md md:rounded-l-md" : "bg-card border border-border md:-ml-px z-10 hover:bg-accent/50 md:last:rounded-r-md"}
                    `}>
                    <div className={`
                        w-8 h-8 flex items-center justify-center rounded-md
                        ${step.isActive ? "bg-[#003366] text-white" : "text-[#003366] dark:text-primary"}
                      `}>
                      <Icon className="w-5 h-5" />
                    </div>
                    
                    <div className={`
                        font-bold font-default whitespace-pre-line text-lg md:text-xl lg:text-xl leading-tight mt-4
                        ${step.isActive ? "text-[#003366]" : "text-foreground"}
                      `}>
                      {step.title}
                    </div>

                    <ChevronRight className={`
                        absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 transition-transform group-hover:translate-x-1
                        ${step.isActive ? "text-[#003366]" : "text-muted-foreground"}
                      `} />
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}